<!-- <app-loader *ngIf="showSpinner"> </app-loader> -->
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid">
    <div class="modal fade payroll-modal pl-0" id="payrollModal" tabindex="-1" role="dialog"
      aria-labelledby="basicModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content payroll-modal-content"
          [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
          <div class="modal-header payroll-modal-header justify-content-center">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="gotoDashboard()">
              <img src="../../../assets/images/modal-close.svg" alt="image">
            </button>
          </div>

          <div class="modal-body payroll-modal-body text-center payroll-modal-body"
            [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
            <img src="../../../assets/images/payroll-img.svg" alt="image">
            <p class="my-3">Enter Your Password To See Your Pay Slip</p>
            <form ng-form="form1" #ff="ngForm" (ngSubmit)="onSubmitPincode(ff)">
              <div class="payroll-form-section">
                <div class="col-12 payroll-form-section-field">
                  <input type="password" name="pin" id="pin" class="form-control pl-4 my-3" placeholder="Enter password"
                    ngModel #title="ngModel" />
                  </div>
                  <div class="col-12 payroll-form-section-btn mt-sm-5 mb-sm-4">
                    <button type="submit" class=""> SHOW PAYROLL</button>
                  </div>
                </div>
              </form>

            </div>

          </div>
        </div>
      </div>
      <!-- modal end -->
      <!-- payroll table -->
      <div class="attendance-filter-section my-2 tabel-header">
        <form #f="ngForm" (ngSubmit)="onSubmit(f)">
          <div class="form-row">
            <div class="col-sm-12 col-md-6">
              <!-- <div class="row">
                <div class="col-sm-6 col-md-6 my-2 attendance-filter-field">
                  <select id="year" name="year" data-toggle="dropdown"
                    class="dropdown-toggle checks-dropdown form-control selectpicker" ngModel #year="ngModel">
                    <option value="2027">2027</option>
                    <option value="2026">2026</option>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                    <option value="2022">2022</option>
                    <option value="2021">2021</option>

                  </select>
                </div>
                <div class="col-sm-6 col-md-6 my-2 attendance-filter-field">
                  <select id="month" name="month" class="checks-dropdown form-control selectpicker" ngModel
                    #month="ngModel">
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>

              </div> -->

            </div>
            <div class="col-sm-4 col-md-6 apply-btns">
              <div class="col-md-6 my-2 attendance-filter-field">
                <!-- <button type="submit" class="form-control apply">Apply</button> -->
              </div>
              <div class="col-md-6 my-2 attendance-filter-field">
                <button type="submit" class="btn text-white loan-btn" (click)="addrequestBtn()">
                  Loan Requests
                </button>
              </div>

            </div>


          </div>
        </form>
      </div>

      <div class="col-12 main-div">
        <div class="parentCurrentYear col-6 pl-1">
          <!-- <button type="button" class="col-4" (click)="payRollEmployee()"
          [ngClass]="{'btnhidden': ishidden, 'btnpayroll': isPayRoll, 'btnemploan': isLoans}">Pay Detail</button>
          <button type="button" class="col-4" (click)="employeeLoansRequest()"
          [ngClass]="{'btnhidden': ishidden, 'btnpayroll': isLoans, 'btnemploan': isPayRoll}">My Loans</button> -->
            <button type="button" class="col-4" (click)="employeeLoansRequest()"
          [ngClass]="{'btnpayroll': isLoans}">My Loans</button>
          @if (showThirdButton) {
            <button type="button" class="col-4" (click)="newFunction()"
              [ngClass]="{'btnhidden': ishidden, 'btnpayroll': isLoans, 'btnemploan': isPayRoll}"
            >New Function</button>
          }

        </div>
      </div>

      <!-- table -->
      @if (isPayRoll) {
        <div class="payroll mt-4">
          <div id="tabel-header" class="attendance-report-table-header d-flex justify-content-around px-3 tabel-header">
            <div class="table-heading text-center">Year</div>
            <div class="table-heading text-center">Month</div>
            <div class="table-heading text-center">Total Salary </div>
            <div class="table-heading text-center ">Deduction</div>
            <div class="table-heading text-center ">This Month Salary</div>
            <div class="table-heading text-center ">View</div>
          </div>
          @for (salary of salaries; track salary) {
            <div class="attendance-report-table-body d-flex justify-content-around px-3 my-4 my-md-0 py-4"
              [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
              <div class="table-cotent">
                <div class="table-content-heading">
                  <h1>Year</h1>
                </div>
                <div class="table-content-value">
                  <h1 class="text-md-center">{{salary.month_year}}</h1>
                </div>
              </div>
              <div class="table-cotent">
                <div class="table-content-heading">
                  <h1>Month</h1>
                </div>
                <div class="table-content-value text-md-center">
                  <h1>{{salary.month_char}}</h1>
                </div>
              </div>
              <div class="table-cotent ">
                <div class="table-content-heading">
                  <h1>Total Salary</h1>
                </div>
                <div class="table-content-value text-md-center">
                  <h1>{{salary.basic_salary === null ? "00" : salary.basic_salary }}/- PKR</h1>
                </div>
              </div>
              <div class="table-cotent">
                <div class="table-content-heading">
                  <h1>Deduction</h1>
                </div>
                <div class="table-content-value text-md-center">
                  <h1> {{salary.total_deduction === null ? "00" : salary.total_deduction}}/- PKR</h1>
                </div>
              </div>
              <div class="table-cotent ">
                <div class="table-content-heading">
                  <h1>This Month Salary</h1>
                </div>
                <div class="table-content-value text-md-center">
                  <h1>{{salary.released_salary === null ? "00" : salary.released_salary }}/- PKR</h1>
                </div>
              </div>
              <div class="table-cotent">
                <div class="table-content-heading">
                  <h1>View</h1>
                </div>
                <div class="table-content-value text-md-center">
                  <img (click)="showSlip(salary)" class="pr-2" src="../../../assets/images/p-view.svg" alt=""
                    style="cursor: pointer;">
                  </div>
                </div>
              </div>
            }
            @if (showSpinner) {
              <app-loader> </app-loader>
            }
          </div>
        }
        <!-- payroll table end -->

        <!-- loan requests -->
        @if (isLoans) {
          <div class="loan-request mt-4">
            <!-- table -->
            <div class="tablewidth mt-4">
              <table class="table">
                <thead>
                  <tr id="tableHead" class="tableHead">
                    <th class="text-center">Appy Date</th>
                    <th class="text-center">Loan Amount</th>
                    <th class="text-center">No of Installments</th>
                    <th class="text-center">Installment</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  @for (data of userLoan; track data) {
                    <tr class="tableData" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                      <td class="text-center">{{data.loan_date}}</td>
                      <td class="text-center">{{data.loan_amount}}</td>
                      <td class="text-center">{{data.loan_duration + ' ' + 'Months'}}</td>
                      <td class="text-center">{{data.installment}}</td>
                      <td class="text-center">
                        <div class="status p-3" [ngStyle]="{'background-color': getStatusColor(data.status)}">
                          {{ data.status }}
                        </div>
                      </td>
                      <td class="action">
                        @if ((data.status != null) && data.status !== 'approved' && data.status !== 'rejected' && data.status !== 'completed') {
                          <div class="action-main d-flex justify-content-between p-2"
                            >
                            <div class="edit" (click)="selectLoanid(data.id)" data-toggle="modal" data-target="#editFormModal">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path
                                  d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z" />
                                </svg>
                              </div>
                              <div class="delete" (click)="selectLoanid(data.id)" data-toggle="modal"
                                data-target="#deleteFormModal"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path
                                  d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" />
                                </svg></div>
                              </div>
                            }
                            @if ((data.status != null) && data.status === 'approved' || data.status === 'completed') {
                              <div class="instalment-detail"
                                >
                                <div class="btn btn-primary" (click)="selectLoanid(data.id)">Detail</div>
                              </div>
                            }
                          </td>
                        </tr>
                        <tr class="tableData" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                          <th class="text-center">Reason:</th>
                          <td colspan="5" class="reason">{{data.loan_reason}}</td>
                        </tr>
                        <tr class="main-div" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
                          <th class="text-center">Document:</th>
                          @if (data.loan_file != null && data.loan_file !== '') {
                            <td colspan="5" class="document-image"
                              class="reason" (click)="selectimage(data.loan_file)" data-toggle="modal" data-target="#imgModal">
                              <img class="doucumnet-source-img" [src]="data.loan_file" alt="Missing Document">
                            </td>
                          }
                          @if (data.loan_file == null || data.loan_file === '') {
                            <td class="reason Warning-td">
                              No Document is Selected
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
                <!-- image modal  -->
                @if (selectimg !== '') {
                  <div class="modal fade" id="imgModal" tabindex="-1" role="dialog" aria-labelledby="dimgModalModalLabel"
                    aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered imgModal" role="document">
                      <div class="modal-content backmodal">
                        <div class="modal-header">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" style="color:white;">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center modal-image">
                          <img [src]="selectimg" alt="Missing Document">
                        </div>
                        <div class="modal-footer">
                          <button (click)="downloadImage()" class="btn btn-primary">Download</button>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <!-- edite loan request modal -->
                <div class="modal fade" id="editFormModal" tabindex="-1" role="dialog" aria-labelledby="editFormModalLabel"
                  aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <form #f="ngForm" id="loan-update" (ngSubmit)="updateLoanReq(f)">
                        <div class="modal-body" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                          <div class="apply-form-main bg-light" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                            <div class="loan-form pt-2 pl-4 pr-4 border"
                              [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                              <div class="mb-4">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                                <h5>Update Loan Request</h5>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <div class="form-group">
                                    <input type="number" class="form-control no-spin-arrows pl-3" name="loanAmountValue"
                                      [(ngModel)]="loanAmountValue" placeholder="Enter Loan Amount*" required />
                                      @if (!loanAmountValue && loanAmountValue !== null) {
                                        <div class="warning">
                                          Loan Amount must be greater than or equal to 0.
                                        </div>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="form-group">
                                      <input type="text" name="loanDate" id="loanDate" class="form-control no-spin-arrows pl-3"
                                        [ngModel]="(userLoanReq != null) ? userLoanReq.loan_date: null" ngModel
                                        placeholder="Enter Date of Apply - mm/dd/yyyy*" onfocus="(this.type='date')"
                                        onblur="(this.type= this.value ? 'date' : 'text')" #loanDate="ngModel" required />
                                        @if (loanDate.touched && loanDate.invalid) {
                                          <div class="warning">
                                            Loan Apply Date is required.
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <label class="title-duration">
                                          <p>Select Duration</p>
                                        </label>
                                        <ul class="nav">
                                          @for (duration of durations; track duration) {
                                            <li class="nav-item">
                                              <div class="nav-link" [class.selected-duration]="duration === selectedDuration"
                                                (click)="selectDuration(duration)">
                                                {{ duration }}
                                              </div>
                                            </li>
                                          }
                                        </ul>
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="form-group">
                                        <label>Installment</label>
                                        <input type="number" name="installmentAmount" [ngModel]="calculatedInstallmentAmount"
                                          class="form-control no-spin-arrows pl-3" readonly />
                                        </div>
                                      </div>
                                      <div class="col-12">
                                        <div class="form-group">
                                          <textarea class="form-control pl-4" id="loanPurpose" rows="3" name="loanPurpose" ngModel
                                          #loanPurpose="ngModel" required [(ngModel)]="reason" (input)="trimText()"></textarea>
                                          @if (loanPurpose.valid && (loanPurpose.dirty || loanPurpose.touched)) {
                                            <div>
                                              @if (reason.trim().length < 150 ) {
                                                <p class="alert alert-warning mt-2">Ensure that the
                                                  entered <strong>Loan Purpose</strong> contains a minimum of 150 characters.</p>
                                                }
                                              </div>
                                            }
                                          </div>
                                        </div>
                                        <div class="col-md-12">
                                          <div class="form-group upload-file">
                                            <!-- Display the selected image if available -->
                                            @if (selectedImage || imagePath) {
                                              <div class="selected-image mr-2">
                                                <img [src]="selectedImage ? selectedImage : imagePath" alt="Selected Image" />
                                              </div>
                                            }
                                            <div class="upfile btn btn-md">
                                              Upload File
                                              <div class="file">
                                                <input type="file" name="profile_image" accept="image/*" id="profile_image"
                                                  accept="image/*" class="file btnPointer" (change)="onFileChange($event)"
                                                  #profile_image_input />
                                                  <input type="hidden" name="loan_file" [(ngModel)]="imagePath" id="loanfile">
                                                </div>
                                              </div>
                                              @if (profileImageInvalid) {
                                                <div class="warning-media mt-1 ml-2">
                                                  Image Size exceeds limit (max 1025 KB).
                                                </div>
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <!--End 1st Section Personal Information -->
                                    </div>
                                  </div>
                                  <div class="modal-footer" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Back</button>
                                    <button type="submit" class="btn btn-primary">Update changes</button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <!-- delete modal -->
                          <!-- Modal -->
                          <div class="modal fade" id="deleteFormModal" #deleteFormModal tabindex="-1" role="dialog"
                            aria-labelledby="deleteFormModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered deleteModal" role="document">
                              <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                <div class="modal-header" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                  <h3 class="modal-title delete-title" id="deleteFormModalLabel">Are You Sure !</h3>
                                </div>
                                <div class="modal-body text-center">
                                  <h6>Do you really want to delete this loan request?</h6>
                                </div>
                                <div class="modal-footer" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
                                  <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
                                  <button type="button" class="btn btn-primary" (click)="deleteLoan(selectedLoanid)">Conform</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }



                      <!-- installment plain -->
                      @if (ishidden) {
                        <div class="loan-request mt-4">
                          <!-- table -->
                          <div class="tablewidth mt-4">
                            <table class="table">
                              <thead>
                                <tr id="tableHead" class="tableHead">
                                  <th class="text-center">Apply Date</th>
                                  <th class="text-center">Total Amount</th>
                                  <th class="text-center">Total Installments</th>
                                  <th class="text-center">Installment</th>
                                  <th class="text-center">Submited Installments</th>
                                  <th class="text-center">Remaining Amount</th>
                                  <th class="text-center">Remaining Installments</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="tableData">
                                  <td class="text-center">{{loandate}}</td>
                                  <td class="text-center">{{loanAmountValue}}</td>
                                  <td class="text-center">{{dateloan}}</td>
                                  <td class="text-center">{{calculatedInstallmentAmount}}</td>
                                  <td class="text-center">{{paid_installment ?? 0}}</td>
                                  <td class="text-center"> {{ ((dateloan ?? 0) - (paid_installment ?? 0)) * (calculatedInstallmentAmount ??
                                  0) }}</td>
                                  <td class="text-center"> {{(dateloan ?? 0 ) - (paid_installment ?? 0)}} </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!-- image modal  -->
                          <div class="modal fade" id="imgModal" tabindex="-1" role="dialog" aria-labelledby="dimgModalModalLabel"
                            aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered imgModal" role="document">
                              <div class="modal-content backmodal">
                                <div class="modal-header">
                                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" style="color:white;">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body text-center modal-image">
                                  @if (selectimg !== 'null') {
                                    <img [src]="selectimg" alt="Missing Document">
                                  }
                                </div>
                                <div class="modal-footer">
                                  <button (click)="downloadImage()" class="btn btn-primary">Download</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- edite loan request modal -->
                          <div class="modal fade" id="editFormModal" tabindex="-1" role="dialog" aria-labelledby="editFormModalLabel"
                            aria-hidden="true">
                            <div class="modal-dialog" role="document">
                              <div class="modal-content">
                                <form #f="ngForm" id="loan-update" (ngSubmit)="updateLoanReq(f)">
                                  <div class="modal-body">
                                    <div class="apply-form-main bg-light">
                                      <div class="loan-form pt-2 pl-4 pr-4 border">
                                        <div class="mb-4">
                                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                          </button>
                                          <h5>Update Loan Request</h5>
                                        </div>
                                        <div class="row">
                                          <!-- <div class="col-md-6">
                                          <div class="form-group">
                                            <input type="number" class="form-control no-spin-arrows pl-3" name="loanAmountValue"
                                              [ngModel]="loanAmountValue  || (userLoanReq != null) ? userLoanReq.loan_amount: null" placeholder="Enter Loan Amount*"  #loanAmountValue="ngModel" required />
                                              <div class="warning" *ngIf="loanAmountValue.touched && loanAmountValue.invalid">
                                                Loan Amount must be greater than or equal to 0.
                                              </div>
                                            </div>
                                          </div> -->
                                          <div class="col-md-6">
                                            <div class="form-group">
                                              <input type="number" class="form-control no-spin-arrows pl-3" name="loanAmountValue"
                                                [(ngModel)]="loanAmountValue" placeholder="Enter Loan Amount*" required />
                                                @if (!loanAmountValue && loanAmountValue !== null) {
                                                  <div class="warning">
                                                    Loan Amount must be greater than or equal to 0.
                                                  </div>
                                                }
                                              </div>
                                            </div>
                                            <div class="col-md-6">
                                              <div class="form-group">
                                                <input type="text" name="loanDate" id="loanDate" class="form-control no-spin-arrows pl-3"
                                                  [ngModel]="(userLoanReq != null) ? userLoanReq.loan_date: null" ngModel
                                                  placeholder="Enter Date of Apply - mm/dd/yyyy*" onfocus="(this.type='date')"
                                                  onblur="(this.type= this.value ? 'date' : 'text')" #loanDate="ngModel" required />
                                                  @if (loanDate.touched && loanDate.invalid) {
                                                    <div class="warning">
                                                      Loan Apply Date is required.
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                              <div class="col-md-6">
                                                <div class="form-group">
                                                  <label class="title-duration">
                                                    <p>Select Duration</p>
                                                  </label>
                                                  <ul class="nav">
                                                    @for (duration of durations; track duration) {
                                                      <li class="nav-item">
                                                        <div class="nav-link" [class.selected-duration]="duration === selectedDuration"
                                                          (click)="selectDuration(duration)">
                                                          {{ duration }}
                                                        </div>
                                                      </li>
                                                    }
                                                  </ul>
                                                </div>
                                              </div>
                                              <div class="col-md-6">
                                                <div class="form-group">
                                                  <label>Installment</label>
                                                  <input type="number" name="installmentAmount" [ngModel]="calculatedInstallmentAmount"
                                                    class="form-control no-spin-arrows pl-3" readonly />
                                                  </div>
                                                </div>
                                                <div class="col-12">
                                                  <div class="form-group">
                                                    <textarea class="form-control pl-4" id="loanPurpose" rows="3" name="loanPurpose" ngModel
                                                    #loanPurpose="ngModel" required [(ngModel)]="reason" (input)="trimText()"></textarea>
                                                    @if (loanPurpose.valid && (loanPurpose.dirty || loanPurpose.touched)) {
                                                      <div>
                                                        @if (reason.trim().length < 150 ) {
                                                          <p class="alert alert-warning mt-2">Ensure that the
                                                            entered <strong>Loan Purpose</strong> contains a minimum of 150 characters.</p>
                                                          }
                                                        </div>
                                                      }
                                                    </div>
                                                  </div>
                                                  <div class="col-md-12">
                                                    <div class="form-group upload-file">
                                                      <!-- Display the selected image if available -->
                                                      @if (selectedImage || imagePath) {
                                                        <div class="selected-image mr-2">
                                                          <img [src]="selectedImage ? selectedImage : imagePath" alt="Selected Image" />
                                                        </div>
                                                      }
                                                      <div class="upfile btn btn-md">
                                                        Upload File
                                                        <div class="file">
                                                          <input type="file" name="profile_image" accept="image/*" id="profile_image"
                                                            accept="image/*" class="file btnPointer" (change)="onFileChange($event)"
                                                            #profile_image_input />
                                                            <input type="hidden" name="loan_file" [(ngModel)]="imagePath" id="loanfile">
                                                          </div>
                                                        </div>
                                                        @if (profileImageInvalid) {
                                                          <div class="warning-media mt-1 ml-2">
                                                            Image Size exceeds limit (max 1025 KB).
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <!--End 1st Section Personal Information -->
                                              </div>
                                            </div>
                                            <div class="modal-footer">
                                              <button type="button" class="btn btn-secondary" data-dismiss="modal">Back</button>
                                              <button type="submit" class="btn btn-primary">Update changes</button>
                                            </div>
                                          </form>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- delete modal -->
                                    <!-- Modal -->
                                    <div class="modal fade" id="deleteFormModal" tabindex="-1" role="dialog" aria-labelledby="deleteFormModalLabel"
                                      aria-hidden="true">
                                      <div class="modal-dialog modal-dialog-centered deleteModal" role="document">
                                        <div class="modal-content">
                                          <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                              <span aria-hidden="true">&times;</span>
                                            </button>
                                            <h3 class="modal-title delete-title" id="deleteFormModalLabel">Are You Sure !</h3>
                                          </div>
                                          <div class="modal-body text-center">
                                            <h6>Do you really want to delete this loan request?</h6>
                                          </div>
                                          <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
                                            <button type="button" class="btn btn-primary" (click)="deleteLoan(selectedLoanid)">Conform</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }



                              </div>
                            </main>